import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Menu } from "@mui/material";
import { MprcButton } from "components/MprcButton";
import { IMenuItem } from "components/MprcButtonDropdown";
import { MprcMenuItemChecked } from "components/MprcMenuItemChecked";
import * as React from "react";
import { useState } from "react";

interface IProps {
    title: string;
    items: IMenuItem[];
    selected: any;
    selectedColor?: MprcColors | "inherit";
    onChange: (selectedValue: any) => void;
}

export const MprcButtonDropdownChecked: React.FC<IProps> = (props) => {

    const { title, selected, selectedColor = "warning", items, onChange } = props;
    const [anchor, setAnchor] = useState<Element | null>(null);

    return (
        <>
            <MprcButton
                text={title}
                size="small"
                color={selected == null ? "inherit" : selectedColor}
                onClick={(e) => setAnchor(e.currentTarget)}
                endIcon={<KeyboardArrowDownIcon />}
            />


            <Menu
                anchorEl={anchor}
                open={anchor != null}
                onClose={() => setAnchor(null)}
            >
                {
                    items.map((v, index) => (
                        <MprcMenuItemChecked
                            key={index}
                            text={v.text} value={v.value} currentSelection={selected}
                            onClick={() => { setAnchor(null); onChange(v.value); }}
                        />
                    ))
                }
            </Menu>
        </>
    );
};
